var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCapIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Cap_icon_svg__clip0_2002_336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.086 271.441l18.271-8.135c20.163-8.977 43.834.109 52.811 20.273l-91.354 40.673c-8.977-20.163.109-43.834 20.272-52.811z",
    fill: "#F93444",
    stroke: "#E2142D",
    strokeWidth: 16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.561 339.499l159.87-71.179c81.936-36.481 178.065.42 214.546 82.356l88.465 198.696-436.86 194.503c-10.995 4.895-23.883-.052-28.779-11.048l-79.599-178.783c-36.48-81.936.42-178.065 82.357-214.545z",
    fill: "#2A848E",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.428 268.321l-13.702 6.096c-81.988 36.5-118.857 132.559-82.357 214.547l88.464 198.691L676.44 549.369l-88.464-198.69c-36.5-81.989-132.56-118.858-214.548-82.358z",
    fill: "#fff",
    stroke: "#CAE0E3",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.44 549.369l-88.464-198.69c-36.5-81.989-132.559-118.858-214.548-82.358l-13.702 6.096",
    stroke: "#33A1AD",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.181 557.633l365.418-162.695c20.163-8.977 43.834.109 52.811 20.273 8.978 20.163-.109 43.834-20.272 52.811L420.636 663.255c-17.959-40.337.207-87.663 40.545-105.622z",
    fill: "#F93444",
    stroke: "#E2142D",
    strokeWidth: 16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.928 461.214c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z",
    fill: "#006C78",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.81 681.666l18.261-8.143M286.619 657.261l18.273-8.142",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.381 363.333a31.818 31.818 0 00.643 24.381l51.154 114.893a5.002 5.002 0 01-2.535 6.607l-22.143 9.857a5.002 5.002 0 01-6.607-2.536l-51.155-114.893a66.074 66.074 0 01-1.321-50.571 66.09 66.09 0 0134.821-36.69 66.076 66.076 0 0150.571-1.322 66.1 66.1 0 0136.691 34.822l51.155 114.892a5.003 5.003 0 01-2.536 6.608l-22.143 9.857a5.002 5.002 0 01-6.607-2.536L479.94 358.928a5.74 5.74 0 00-.404-.75c-9.5-14.571-26.608-18.655-40.381-12.524a31.906 31.906 0 00-16.786 17.691l.012-.012z",
    fill: "#2A848E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.262 414.559c-2.536-.559-8.857 6.595-9.905 12.512a3.098 3.098 0 00-2.286.095l-2.809 1.25a3.109 3.109 0 00-1 .703c-.25.274-.464.595-.607.94-5.095-3.178-14.643-3.274-15.929-1.012-1.595 2.822 5.965 20.476 9.155 20.56 2.548.071 8.786-6.786 9.857-12.572.357.131.738.191 1.131.179a2.89 2.89 0 001.191-.262l2.809-1.25a3.1 3.1 0 001.607-1.667c5.012 3.072 14.286 3.036 15.941 1.096 2.071-2.429-5.988-19.858-9.155-20.56v-.012z",
    fill: "#ED1A3C",
    stroke: "#ED1A3C",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Cap_icon_svg__clip0_2002_336"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapIcon);
export default ForwardRef;